export default __webpack_public_path__ + "static/media/phoneSocialSm3.69ddc3fa.png";